module.exports = __webpack_public_path__ + "media/images/pc/articles/recommend_02-12494b88d0dc7c2c84e04e2c99fe8ab6.webp";